/**
 * Single source of truth for "X minute(s)/hour(s)/day(s) ago" labels.
 * Past one month, falls back to a localized date so labels don't grow
 * unbounded. `now` is injectable so callers can pin time in tests.
 */
export function formatRelativeTime(
  input: string | null | undefined,
  now?: Date,
): string {
  if (!input) return "—";
  const date = new Date(input);
  if (Number.isNaN(date.getTime())) return "—";
  const reference = now ?? new Date();
  const diffMs = reference.getTime() - date.getTime();
  const diffMinutes = Math.max(1, Math.round(diffMs / 60_000));
  if (diffMinutes < 60)
    return `${diffMinutes} minute${diffMinutes === 1 ? "" : "s"} ago`;
  const diffHours = Math.round(diffMinutes / 60);
  if (diffHours < 24)
    return `${diffHours} hour${diffHours === 1 ? "" : "s"} ago`;
  const diffDays = Math.round(diffHours / 24);
  if (diffDays < 30)
    return `${diffDays} day${diffDays === 1 ? "" : "s"} ago`;
  return date.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}
